<template>
  <fragment>
    <div class="row" v-if="entityType!='none'">
      <div class="col-12">
        <taglist
          v-model="selectedTags"
          :readOnlyReserved="false"
          v-on:setChange="loaddata"
          :types="['allegati']"
        ></taglist>
        <input
          type="text"
          class="form-control"
          v-model="query"
          placeholder="Ricerca file"
          v-on:change="loaddata"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-right">
        <div class="button-list" v-if="entityType!='none'">
          <button
            type="button"
            class="btn btn-round btn-primary-rgba"
            title="Visualizza a griglia"
            @click="attachmentList = false"
          >
            <i class="feather icon-grid"></i>
          </button>
          <button
            type="button"
            class="btn btn-round btn-secondary-rgba"
            title="Visualizza a lista"
            @click="attachmentList = true"
          >
            <i class="feather icon-list"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="row" v-if="isloading">
      <div class="col-12 text-center">
        <span
          class="spinner-grow spinner-grow-sm"
          role="status"
          aria-hidden="true"
        ></span>
        Caricamento in corso
      </div>
    </div>
    <div class="row" v-if="!attachments || attachments.length == 0">
      <div class="col-12"><noresult /></div>
    </div>
    <div class="row" v-if="attachmentList && !isloading">
      <div class="col-12">
        <table class="table table-border">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col">File</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in attachments" :key="item.attachmentId">
              <th scope="row">
                <i
                  class="card-img-top fa-2x text-center p-1"
                  :class="getExtensionIcon(item.fileExtension)"
                ></i>
              </th>
              <td>
                <h6 class="cart-title attachment-filename" :title="item.title">
                  <a
                    class="text-primary"
                    href="#"
                    v-on:click.stop="
                      downloadAttachment(
                        item.attachmentId,
                        item.originalFileName
                      )
                    "
                    >{{ item.title }}</a
                  >
                </h6>
                <blockquote class="blockquote">
                  {{ item.description }}
                </blockquote>
                <tags :value="item.tags" />
              </td>

              <td>
                <div class="dropdown">
                  <button
                    class="btn btn-link l-h-20 p-0 font-18 float-right"
                    type="button"
                    id="CustomdropdownMenuButton8"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="feather icon-more-horizontal-"></i>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="CustomdropdownMenuButton8"
                  >
                    <a
                      class="dropdown-item font-13"
                      href=""
                      v-on:click.stop="
                        downloadAttachment(
                          item.attachmentId,
                          item.originalFileName
                        )
                      "
                      ><i class="feather icon-download-cloud"></i> Download
                    </a>
                    <a v-if="!readOnly && entityType!='none'"
                      class="dropdown-item font-13 cursor-pointer"
                      v-on:click.stop="editAttachment(item.attachmentId)"
                      ><i class="feather icon-edit"></i> Modifica</a
                    >
                    <a v-if="!readOnly"
                      class="dropdown-item font-13 text-danger cursor-pointer"
                      v-on:click.stop="removeAttachment(item.attachmentId)"
                      ><i class="feather icon-trash"></i> Elimina</a
                    >
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row" v-if="!attachmentList && !isloading">
      <div
        class="col-md-3"
        v-for="item in attachments"
        :key="item.attachmentId"
      >
        <div class="card border-light m-b-30">
          <div class="card-header">
            <div class="row align-items-center">
              <div class="col-9">
                <span class="badge badge-pill badge-light">{{
                  item.fileExtension
                }}</span>
              </div>
              <div class="col-3">
                <div class="dropdown">
                  <button
                    class="btn btn-link l-h-20 p-0 font-18 float-right"
                    type="button"
                    id="CustomdropdownMenuButton8"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="feather icon-more-horizontal-"></i>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="CustomdropdownMenuButton8"
                  >
                    <a
                      class="dropdown-item font-13"
                      href=""
                      v-on:click.stop="
                        downloadAttachment(
                          item.attachmentId,
                          item.originalFileName
                        )
                      "
                      ><i class="feather icon-download-cloud"></i> Download
                    </a>
                    <a v-if="!readOnly  && entityType!='none'"
                      class="dropdown-item font-13 cursor-pointer"
                      v-on:click.stop="editAttachment(item.attachmentId)"
                      ><i class="feather icon-edit"></i> Modifica</a
                    >
                    <a v-if="!readOnly"
                      class="dropdown-item font-13 text-danger cursor-pointer"
                      v-on:click.stop="removeAttachment(item.attachmentId)"
                      ><i class="feather icon-trash"></i> Elimina</a
                    >
                  </div>
                </div>
              </div>
              <div class="col-12">
                <i
                  class="card-img-top fa-4x text-center p-1"
                  src=""
                  alt="Generic placeholder image"
                  :class="getExtensionIcon(item.fileExtension)"
                ></i>
              </div>
            </div>
          </div>

          <div class="card-body">
            <h6 class="cart-title attachment-filename" :title="item.title">
              <a
                class="text-primary"
                href="#"
                v-on:click.stop="
                  downloadAttachment(item.attachmentId, item.originalFileName)
                "
                >{{ item.title }}</a
              >
            </h6>
            <blockquote class="blockquote">{{ item.description }}</blockquote>
            <tags :value="item.tags"  v-if="entityType!='none'" />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <vue-dropzone v-if="!readOnly"
          ref="myVueDropzone"
          id="attachment-dropzone"
          name="attachment-dropzone"
          :options="dropzoneOptions()"
          :useCustomSlot="true"
        >
          <div class="dropzone-custom-content">
            <h3 class="dropzone-custom-title">
              Trascina i file qui per il caricamento
            </h3>
            <div class="subtitle">...o fai click per caricarlo dal tuo pc</div>
          </div>
        </vue-dropzone>
      </div>
    </div>
    <a ref="attachmentA"></a>

    <div
      class="modal fade"
      id="attachmentModalEdit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog slideInUp animated" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalCenterTitle">
              Modifica Allegato
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div id="attachmentinformation" v-if="attachment">
              <div class="row">
                <taglist
                  v-model="attachment.tags"
                  :types="['allegati']"
                ></taglist>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <ValidationProvider
                      v-slot="{ classes, errors }"
                      immediate
                      slim
                      rules="required"
                    >
                      <label class="col-form-label" for="attachmentTitle"
                        >Titolo</label
                      >
                      <input
                        type="text"
                        class="form-control required"
                        id="attachmentTitle"
                        name="attachmentTitle"
                        placeholder="Titolo allegato"
                        v-model="attachment.title"
                        :class="classes"
                      />
                    </ValidationProvider>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label class="col-form-label" for="attachmentDescription"
                      >Breve Descrizione</label
                    >
                    <textarea
                      class="form-control"
                      id="attachmentDescription"
                      name="attachmentDescription"
                      placeholder="breve descrizione"
                      v-model="attachment.description"
                      :class="classes"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-xs btn-danger-rgba mr-2"
              data-dismiss="modal"
            >
              Annulla
            </button>
            <button
              type="button"
              class="btn btn-xs btn-primary-rgba mr-2"
              v-on:click.stop="saveAttachment"
            >
              Salva
            </button>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>
<style scoped>
.attachment-filename {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<script>
let vm_scope;
import axios from "axios";
export default {
  name: "attachments",

  props: {
    readOnly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    value: {
      type: String,
      required: true,
    },
    entityType: {
      type: String,
      required: false,
      default: () => "company",
    },
    readOnlyReserved: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  components: {},
  data() {
    return {
      options: [],
      selectedTag: null,
      attachment: null,
      attachmentList: false,
      attachments: [],
      selectedTags: [],
      query: "",
      isloading: false,
    };
  },
  mounted() {
    setTimeout(this.loaddata, 200);
  },
  methods: {
    getExtensionIcon: function (ext) {
      if (ext) ext = ext.toLowerCase();
      else ext = "";
      switch (ext) {
        case ".txt":
          return "fa fa-file-text-o";
        case ".doc":
        case ".docx":
          return "fa fa-file-word-o  text-info";
        case ".xls":
        case ".xlsx":
        case ".csv":
          return "fa fa-file-excel-o text-success";
        case ".jpg":
        case ".jpeg":
        case ".png":
        case ".bmp":
        case ".tiff":
          return "fa fa-image-o  text-info";
        case ".pdf":
          return "fa fa-file-pdf-o text-danger";
        case ".wav":
        case ".mp3":
          return "fa fa-file-audio-o text-warning";
        case ".ppt":
        case ".pptx":
          return "fa fa-file-powerpoint-o text-warning";
        case ".zip":
        case ".rar":
        case ".7z":
          return "fa fa-file-archive-o  text-warning";
        default:
          return "fa fa-file-o";
      }
    },
    dropzoneOptions: function () {
      var me = this;
      vm_scope = this;
      function url() {
        return (
          window.SETTINGS.apiUrl +
          "/attachment/upload/" +
          vm_scope.entityType +
          "/" +
          vm_scope.value
        );
      }
      return {
        url: url,
        headers: { Authorization: "Bearer " + this.$store.state.user.token },
        success: function (a, b) {
          this.removeFile(a);
          vm_scope.loaddata();
        },
      };
    },
    removeAttachment: function (id) {
      var me = this;
      this.$swal({
        title: ``,
        html: `Sicuri di voler eliminare la risorsa?`,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          axios.delete("attachment/" + id).then((response) => {
            me.loaddata();
          });
        }
      });
    },
    editAttachment: function (id) {
      this.attachment = null;
      var me = this;
      axios.get(`attachment/${id}`).then(function (result) {
        me.attachment = result.data;
        $("#attachmentModalEdit").modal();
      });

      return false;
    },
    saveAttachment: function () {
      var me = this;
      axios.put(`attachment`, this.attachment).then(function (result) {
        me.attachment = null;
        me.loaddata();
      });

      return false;
    },
    downloadAttachment: function (id, o) {
      var me = this;
      var url = "";

      axios
        .get(`attachment/download/${id}`, { responseType: "blob" })
        .then(function (result) {
          var blob = new Blob([result.data], {
            type: result.headers["content-type"],
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // for IE
            window.navigator.msSaveOrOpenBlob(blob, o);
          } else {
            me.$refs.attachmentA.href = URL.createObjectURL(blob);
            me.$refs.attachmentA.download = o;
            me.$refs.attachmentA.click();
          }
        });
    },
    loaddata: function () {
      $("#attachmentModalEdit").modal("hide");
      var me = this;
      this.isloading = true;
      axios
        .post(`attachment/${me.value}?type=${me.entityType}`, [
          { key: "tags", value: JSON.stringify(me.selectedTags) },
          { key: "query", value: me.query },
        ])
        .then((response) => {
          me.attachments = response.data.data;
          me.isloading = false;
        });
    },
  },
};
</script>
